import { ReactionResponse } from "@shared/Types/Reactions/ReactionTypes.types";
import { publish } from "@infrastructure/Events/EventBus";
import { ReactionEntityName } from "../Reactions.types";
import { OnReactionEvent } from "./OnReactionEvent.types";

const ON_REACTION_EVENT_NAME_PREFIX = "on-reaction";

export const getOnReactionEventName = (
    entityName: ReactionEntityName,
): string => {
    return `${ON_REACTION_EVENT_NAME_PREFIX}-${entityName}`;
};

export const publishOnReactionEvent = (
    entityName: ReactionEntityName,
    entityId: string,
    reactions: ReactionResponse,
): void => {
    const event: OnReactionEvent = {
        name: getOnReactionEventName(entityName),
        entityId,
        reactions,
    };
    publish(event);
};
